module.exports = __webpack_public_path__ + "90f78696e82f2b6dce450a641bc3f84e.svg";